import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_sn",
  "use": "icon-control_sn-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-control_sn\"><g transform=\"translate(2 3)\" stroke=\"currentColor\" fill=\"transparent\"><circle cx=\"1\" cy=\"1\" r=\"1\" /><circle cx=\"1\" cy=\"5\" r=\"1\" /><circle cx=\"1\" cy=\"9\" r=\"1\" /><path stroke-linecap=\"round\" d=\"M4 1h7M4 5h7M4 9h7\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol